// src/HomeScreen.jsx
import React, { useState, useEffect } from "react"; 
import { Button } from "./components/ui/button";
import { Camera, List, HelpCircle, LogOut, Users, AlertCircle } from "lucide-react"; // --> NOVO: Adicionado AlertCircle
import { useNavigate, useLocation } from "react-router-dom";
import { useUser } from "./context/UserContext";
import ReportIssueModal from './components/ReportIssueModal'; 

export default function HomeScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useUser();
  const [isReportModalVisible, setIsReportModalVisible] = useState(false); 

  // Determina se o usuário é um admin
  const isAdmin = user && (user.role === 'admin-dev' || user.role === 'admin-op');

  useEffect(() => {
    if (location.state?.fromPhoto) {
      window.history.replaceState({}, document.title);
      window.location.reload();
    }
  }, [location]);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="relative min-h-screen bg-white px-4 py-8 text-gray-900">
      <div className="flex justify-center mb-5">
        <img src={process.env.PUBLIC_URL + '/ic_logo_header.png'} alt="SPX Express" className="h-36" />
      </div>
      <div className="text-2xl font-medium mb-16">
        Olá,<br />
        <span className="font-bold text-4xl">Operador!</span>
      </div>
      <div className="mb-12">
        <div className="grid grid-cols-2 gap-4">
          <div className="bg-[#EE4D2D] text-white shadow-md rounded-lg">
            <button
              onClick={() => navigate("/photo")}
              className="w-full h-full p-6 flex flex-col items-center justify-center hover:bg-[#D03F2A] transition-colors rounded-lg"
            >
              <Camera size={32} />
              <span className="mt-2 font-semibold text-xl">Tirar Foto</span>
            </button>
          </div>
          <div className="bg-[#EE4D2D] text-white shadow-md rounded-lg">
            <button
              onClick={() => navigate("/historico")}
              className="w-full h-full p-6 flex flex-col items-center justify-center hover:bg-[#D03F2A] transition-colors rounded-lg"
            >
              <List size={32} />
              <span className="mt-2 font-semibold text-xl">Histórico</span>
            </button>
          </div>
        </div>
      </div>
      <div className="mt-16">
        <div className="space-y-3">
          
          {isAdmin && (
            <Button
              onClick={() => navigate('/manage-users')}
              variant="outline"
              className="w-full flex justify-start items-center text-xl py-8 border-gray-300 rounded-lg"
            >
              <Users className="mr-4 ml-2 text-[#EE4D2D]" size={28} />
              <span className="font-semibold text-gray-700">Gerenciar Usuários</span>
            </Button>
          )}

          <Button
            onClick={() => navigate('/faq')}
            variant="outline"
            className="w-full flex justify-start items-center text-xl py-8 border-gray-300 rounded-lg"
          >
            <HelpCircle className="mr-4 ml-2 text-[#EE4D2D]" size={28} />
            <span className="font-semibold text-gray-700">Dúvidas Frequentes</span>
          </Button>

          <Button
            onClick={handleLogout}
            variant="outline"
            className="w-full flex justify-start items-center text-xl py-8 border-gray-300 rounded-lg"
          >
            <LogOut className="mr-4 ml-2 text-[#EE4D2D]" size={28} />
            <span className="font-semibold text-gray-700">Sair</span>
          </Button>
        </div>
      </div>
      
      <button
        onClick={() => setIsReportModalVisible(true)}
        className="fixed bottom-6 right-6 bg-[#EE4D2D] text-white p-3 rounded-full shadow-lg hover:bg-[#D03F2A] transition-all duration-300 z-40 opacity-80 hover:opacity-100"
        title="Relatar um Problema"
      >
        <AlertCircle size={24} />
      </button>

      <ReportIssueModal
        isVisible={isReportModalVisible}
        onClose={() => setIsReportModalVisible(false)}
        screenName="home"
      />
    </div>
  );
}